import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { EMPTY, catchError, throwError } from 'rxjs';

import { ToastService } from '../services/toast.service';

// Intercepts 403 `env_access_read_only` and shows a descriptive toast.
// Must be registered AFTER `authInterceptor` so 401s are handled first.
export const envAccessInterceptor: HttpInterceptorFn = (req, next) => {
  const toast = inject(ToastService);

  return next(req).pipe(
    catchError((err: unknown) => {
      if (
        err instanceof HttpErrorResponse &&
        err.status === 403 &&
        err.error?.error === 'env_access_read_only'
      ) {
        const env: string  = err.error.env  ?? 'this environment';
        const role: string = err.error.role ?? 'your current role';
        toast.error(
          `Read-only access on ${env}. Your role (${role}) cannot make changes in this environment.`,
        );
        return EMPTY; // toast is the complete user-facing response - swallow to prevent double error UI
      }
      return throwError(() => err);
    }),
  );
};
